import DiagnosticProposalLeadValue from "@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/components/AuctionProposal/DiagnosticProposalLeadValue";
import ExecutionProposalLeadValue from "@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/components/AuctionProposal/ExecutionProposalLeadValue";
import { AuctionProposalLeadValueProps } from "@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/types/auctionProposalLeadValue.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type";
import { ComponentType } from "react";

/**
 * Lookup table: directive entry klass -> component that renders the highlighted
 * (lead) proposal value. Register a new klass here instead of branching in the
 * component; a klass without an entry simply renders no lead value.
 */
export const auctionProposalLeadValueByDirectiveEntryKlass: Partial<{
  [DirectiveEntry in MaintenanceForwardingsDirectiveEntryKlass]: ComponentType<AuctionProposalLeadValueProps>;
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: ExecutionProposalLeadValue,
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: DiagnosticProposalLeadValue,
};
